<template>
	<span :class="classes">
		<FontAwesomeIcon
			v-if="isToggled"
			:icon="['fas', 'star']"
			@click="onStarClicked"
		/>
		<FontAwesomeIcon
			v-else
			:icon="['far', 'star']"
			@click="onStarClicked"
		/>
	</span>
</template>

<script>

export default {
	name: "ToggleStar",
	emits: [
		"change",
	],
	props: {
		className: {
			type: String,
			default: "",
		},
		isToggled: {
			type: Boolean,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				"toggle-star": true,
				"toggle-star--toggled": this.isToggled,
				"toggle-star--disabled": this.disabled,
				[ this.className ]: !!this.className,
			};
		},
	},
	methods: {
		onStarClicked( e ) {
			e.stopPropagation();
			this.$emit( "change", { isToggled: !this.isToggled, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.toggle-star {
	cursor: pointer;

	* {
		color: $toggle-star-color;
	}
}

.toggle-star--toggled:not(.toggle-star--disabled) {
	* {
		color: $toggle-star-toggled-color;
	}
}

.toggle-star--disabled {
	cursor: not-allowed;

	* {
		color: $toggle-star-disabled-color;
	}
}
</style>
